import { Observable, of } from 'rxjs';
import { delay, switchMap } from 'rxjs/operators';

import { Injectable } from '@angular/core';
import { PreloadingStrategy, Route } from '@angular/router';

const UrlContains = (key) => location?.pathname?.startsWith(`/${key}/`);
@Injectable()
export class AppPreloadingStrategy implements PreloadingStrategy {
  preload(route: Route, load: any): Observable<any> {
    if (
      UrlContains('billed-usage-report') ||
      UrlContains('payment-methods') ||
      UrlContains('oauth') ||
      UrlContains('signup')
    )
      return of(null);
    else if (route.data?.preload)
      return of(true).pipe(
        delay(7000),
        switchMap((b) => load()),
      );

    return of(null);
  }
}
